import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { InfoOutlined, WarningAmberOutlined } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import { colors, radii } from '../../styles/tokens';

export type InfoPanelVariant = 'info' | 'warning';

export interface InfoPanelProps {
  title: string;
  children: React.ReactNode;
  variant?: InfoPanelVariant;
}

const variantStyles: Record<InfoPanelVariant, { accent: string; icon: React.ReactNode }> = {
  info: {
    accent: colors.primary,
    icon: <InfoOutlined sx={{ fontSize: 22, mt: 0.25, flexShrink: 0 }} />,
  },
  warning: {
    accent: colors.warning,
    icon: <WarningAmberOutlined sx={{ fontSize: 22, mt: 0.25, flexShrink: 0 }} />,
  },
};

export const InfoPanel: React.FC<InfoPanelProps> = ({ title, children, variant = 'info' }) => {
  const style = variantStyles[variant];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        bgcolor: alpha(style.accent, 0.05),
        border: `1px solid ${alpha(style.accent, 0.25)}`,
        borderRadius: `${radii.card}px`,
        display: 'flex',
        gap: 2,
        alignItems: 'flex-start',
      }}
    >
      <Box sx={{ color: style.accent, display: 'flex' }}>{style.icon}</Box>
      <Box>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 700, color: colors.textPrimary, mb: 0.5 }}
        >
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: colors.textSecondary, lineHeight: 1.6 }}>
          {children}
        </Typography>
      </Box>
    </Paper>
  );
};
